import {ApplicationContextController} from '@mintdata-wsp/common/controllers/context/ApplicationContextController';
import {User} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

export class WspApplicationContextController implements ApplicationContextController
{
    async currentUser():Promise<User>
    {
        return rootState.userSession && rootState.userSession.currentUser;
    }

    currentOrganizationSid():string
    {
        return rootState.userSession && rootState.userSession.currentOrganization.siteId;
    }

    cacheScope():string
    {
        return controllers.ui.openDesign.getOpenDesign().designRef.designId.toString();
    }

    isStandaloneMode():boolean
    {
        return false;
    }

    currentOrganizationName():string
    {
        return rootState.userSession && rootState.userSession.currentOrganization.name;
    }
}
